<template>
  <div>
    <!-- 版心 -->
    <div class="banXin">
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/logo2.png" alt="" />
        <h2>NLPIR在线演示平台</h2>
      </div>
      <!-- 背景图片区域 -->
      <transition name="slide">
        <div class="imgBox" v-show="imgShow">
          <img :src="imgSrc" width="100%" height="100%" class="imgTow" alt="" />
          <h1 class="oneh1" v-show="imgShow">
            二十年积累 &nbsp;&nbsp; 四十万用户认可
          </h1>
          <h1 class="twoh1" v-show="imgShow">
            NLPIR语义分析从“芯”定义人工智能
          </h1>
        </div>
      </transition>
      <!-- 内容 -->
      <div
        class="analyze"
        id="text"
        contenteditable="plaintext-only"
        v-html="content"
        ref="refPinyin"
      ></div>
      <!-- 操作区域 -->
      <div class="Fenxi">
        <p>实时测试语料</p>
        <input type="text" placeholder="URL:" class="input" v-model="url" />
        <el-select
          v-model="value"
          clearable
          placeholder="选择网站"
          @change="selectOne"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <button class="btn" @click="zh_tran">繁体转换</button>
        <button class="btn" @click="py($event)">拼音转换</button>
        <button class="state" @click="toggleShopShow">开始分析</button>
      </div>
      <!-- 结果区域 -->
      <transition name="slide-fade">
        <div class="result" v-show="shopShow">
          <!-- teb -->
          <!-- teb切换区域 -->
          <div class="tabTable">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="分词标注" name="first">
                <participle ref="mychild"></participle>
              </el-tab-pane>
              <el-tab-pane label="实体抽取" name="second">
                <entity
                  v-if="'second' === activeName"
                  :analyze="analyze"
                ></entity>
              </el-tab-pane>
              <el-tab-pane label="词频统计" name="third">
                <wordfrequency
                  v-if="'third' === activeName"
                  :analyze="analyze"
                ></wordfrequency>
              </el-tab-pane>
              <el-tab-pane label="文本分类" name="fourth">
                <textclass
                  v-if="'fourth' === activeName"
                  :analyze="analyze"
                ></textclass>
              </el-tab-pane>
              <el-tab-pane label="情感分析" name="five">
                <emotion
                  v-if="'five' === activeName"
                  :analyze="analyze"
                ></emotion>
              </el-tab-pane>
              <el-tab-pane label="关键词提取" name="six">
                <antistop
                  v-if="'six' === activeName"
                  :analyze="analyze"
                ></antistop>
              </el-tab-pane>
              <el-tab-pane label="文本摘要" name="eight">
                <textsum
                  v-if="'eight' === activeName"
                  :analyze="analyze"
                ></textsum>
              </el-tab-pane>
              <el-tab-pane label="敏感词" name="ten">
                <sensitivity
                  v-if="'ten' === activeName"
                  :analyze="analyze"
                ></sensitivity>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </transition>
      <!-- 页脚 -->
      <div class="footer">
        <p>
          NLPIR Big Data Search and Mining Platform Copyright | 2017(C) Big Data
          Search and Mining Lab | Beijing Institute of Technology All rights
          reserved.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
// #引入汉字转拼音插件文件
import vPinyin from "../utils/vue-py";
// 繁体
import complexFont from "../lang/chinese";
import axios from "axios";
// 字组件
import Participle from "../components/Participle.vue";
// 文本拽要
import Textsum from "../components/Textsum.vue";
// 实体
import Entity from "../components/Entity.vue";
//  词频统计
import Wordfrequency from "../components/Wordfrequency.vue";
// 情感分析
import Emotion from "../components/Emotion.vue";
// 关键词
import Antistop from "../components/Antistop.vue";
// 文本分类
import Textclass from "../components/Textclass.vue";
// 敏感词
import Sensitivity from "../components/Sensitivity.vue";
export default {
  data() {
    return {
      activeName: "first",
      shopShow: false,
      imgShow: true,
      imgSrc: require("../assets/banner.png"),
      imgTow: require("../assets/zhushijue.png"),
      note: {
        backgroundImage: "url(" + require("../assets/beijing.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%,100%",
      },
      options: [],
      optionValue: [],
      value: "",
      url: "",
      flag: true,
      content: "",
      analyze: "",
    };
  },
  components: {
    Participle,
    Textsum,
    Entity,
    Wordfrequency,
    Emotion,
    Antistop,
    Textclass,
    Sensitivity,
  },
  created() {},
  computed: {},
  beforeMount() {},
  mounted() {
    // this.grabber();
    this.eptions();
  },
  methods: {
    async varify() {
      let that = this;
      if (!that.$refs.refPinyin.innerText) {
        return that.$message.error("分析内容为空！");
      }
      that.imgShow = false;
      that.shopShow = true; //使false变为true显示
      //  切换回 分词第一项
      that.activeName = "first";
      //  获取需要分析的文本
      that.analyze = that.$refs.refPinyin.innerText;
      // 存进VueX
      that.$store.commit("details", that.analyze);
      // 调取分词子组件中的两个方法
      await that.$refs.mychild.Fenci(that.analyze);
      await that.$refs.mychild.Xinci(that.analyze);
    },
    toggleShopShow() {
      this.varify();
    },
    // 拼音转换
    py(e) {
      let flag = this.flag;
      if (flag) {
        let eltext = this.$refs.refPinyin.innerText;
        // #调用汉字转拼音方法
        let namePinyin = vPinyin.chineseToPinYin(eltext);
        $("#text").empty();
        $("#text").html(namePinyin);
        this.flag = false;
      } else {
        let eltext = this.$refs.refPinyin.innerText;
        $("#text").empty();
        $("#text").html(eltext);
        this.flag = true;
      }
    },
    // 繁体转换
    zh_tran() {
      let flag = this.flag;
      if (flag) {
        var content = this.content;
        $("#text").empty();
        $("#text").html(complexFont.string_prototype_s2t(content));
        this.flag = false;
      } else {
        var content = this.content;
        $("#text").empty();
        $("#text").html(complexFont.string_prototype_t2s(content));
        this.flag = true;
      }
    },
    // 选项卡
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    //  获取抓取网站下拉框数据
    async eptions() {
      const { data: res } = await this.$http.get("/spider/mapping");
      res["特定敏感词"] = "特定敏感词";
      let newKey = [];
      let newValue = [];
      for (let i in res) {
        newKey.push(i);
        newValue.push(res[i]);
      }
      this.options = newKey;
      this.optionMapping = res;
    },
    //  获取到下拉框默认值
    async select() {
      let value = this.value;
      if (value) {
        const { data: res } = await this.$http.get("/spider");
        // 这里是给返回的数据追加一项数组
        res["特定敏感词"] = [
          {
            content:
              "發嘌量大优惠 ,六人一口cai,一次性交费500元,sm性交,一袋漂白粉,白粉交易",
            url: "",
          },
        ];
        // 这里是找与数组匹配的键名
        let response = res[this.optionMapping[value]];
        //  这里是取随机获取匹配到的数组中的某一项对象
        var item = response[Math.floor(Math.random() * response.length)];
        this.content = item.content;
        this.url = item.url;
      }
    },
    // 获取抓取的数据
    async selectOne(value) {
      if (value) {
        const { data: res } = await this.$http.get("/spider");
        // 这里是给返回的数据追加一项数组
        res["特定敏感词"] = [
          {
            content:
              "發嘌量大优惠 ,六人一口cai,一次性交费500元,sm性交,一袋漂白粉,白粉交易",
            url: "",
          },
        ];
        // 这里是找与数组匹配的键名
        let response = res[this.optionMapping[value]];
        //  这里是取随机获取匹配到的数组中的某一项对象
        var item = response[Math.floor(Math.random() * response.length)];
        this.content = item.content;
        this.url = item.url;
      }
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
.title {
  width: 100%;
  height: 60px;
  background-color: #000000;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 50px;

  h2 {
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-left: 6px;
  }
}
.imgBox {
  left: 0;
  top: 0;
  width: 100%;
  height: 400px; /**宽高100%是为了图片铺满屏幕 */
  border-right: none;
  border-left: none;
  box-shadow: 8px 0px 8px 0px #10a4b2;
  box-sizing: border-box;
  position: relative;
  .oneh1 {
    position: absolute;
    top: 33%;
    left: 13%;
    font-size: 38px;
    font-family: heiti;
    font-weight: bold;
    letter-spacing: 6px;
  }
  .twoh1 {
    position: absolute;
    top: 48%;
    left: 13%;
    font-size: 38px;
    font-family: heiti;
    font-weight: bold;
    letter-spacing: 6px;
  }
  .imgTow {
    background-size: contain; /* 使图片平铺满整个浏览器（从宽和高的最大需求方面来满足，会使某些部分无法显示在区域中） */
    background-position: center center;
    z-index: -1;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.analyze {
  width: 96%;
  height: 345px;
  box-shadow: 2px 0px 2px 0px #10a4b2;
  border: 1px solid #10a4b2;
  border-radius: 6px 6px 0px 0px;
  margin: 30px auto 0px auto;
  color: #fff;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  font-family: serif;
}
.Fenxi {
  width: 95.9%;
  height: 40px;
  box-shadow: 2px 0px 2px 0px #10a4b2;
  border: 1px solid #10a4b2;
  border-top: none;
  border-radius: 0px 0px 6px 6px;
  margin: 0px auto;
  display: flex;
  align-items: center;
  p {
    font-size: 12px;
    color: #fff;
    padding: 20px;
  }
  .input {
    min-width: 20%;
    max-width: 40%;
    background-color: #000000;
    border: 1px solid #10a4b2;
    border-radius: 5px;
    height: 20px;
    color: #fff;
    padding-left: 8px;
  }
  .btn {
    width: 8%;
    height: 20px;
    background-color: #000;
    color: #fff;
    border-radius: 5px;
    margin-left: 5%;
    border: 1px solid #10a4b2;
  }
  .state {
    margin-left: auto;
    height: 100%;
    width: 10%;
    background-color: #10a6b4;
    border: 0;
    color: #fff;
  }
}
.result {
  width: 96%;
  margin: 0px auto 0px auto;
  color: #fff;
  box-sizing: border-box;
  overflow: auto;
  .tabTable .el-tab-pane {
    height: 360px;
    box-shadow: 2px 0px 2px 0px #10a4b2;
    border: 1px solid #10a4b2;
    border-radius: 10px;
  }
  .tabTable {
    height: 450px;
  }
}
.slide-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}
.slide-leave-active,
.mybox-enter {
  height: 0px !important;
}
.slide-leave,
.mybox-enter-active {
  height: 400px;
}
.slide-fade-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active,
.mybox-enter {
  height: 0px !important;
}
.slide-fade-leave,
.mybox-enter-active {
  height: 500px;
}
.footer {
  width: 100%;
  height: 60px;
  background-color: #000;
  // position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  text-align: center;
  .p {
    width: 60%;
    height: 1px;
    margin: 15px auto;
    background-color: #fff;
  }
  p {
    font-size: 12px;
  }
}
@media screen and (max-width: 1400px) and (min-width: 1200px) {
  .imgBox {
    left: 0;
    top: 0;
    width: 100%;
    height: 242px; /**宽高100%是为了图片铺满屏幕 */
    border-right: none;
    border-left: none;
    box-shadow: 8px 0px 8px 0px #10a4b2;
    box-sizing: border-box;
    position: relative;
    .oneh1 {
      position: absolute;
      top: 31%;
      left: 13%;
      font-size: 24px;
      font-family: heiti;
      font-weight: bold;
      letter-spacing: 6px;
    }
    .twoh1 {
      position: absolute;
      top: 47%;
      left: 13%;
      font-size: 24px;
      font-family: heiti;
      font-weight: bold;
      letter-spacing: 6px;
    }
  }
  .analyze {
    width: 95%;
    height: 200px;
    font-size: 13px;
    box-shadow: 2px 0px 2px 0px #10a4b2;
    border: 1px solid #10a4b2;
    border-radius: 6px 6px 0px 0px;
    margin: 20px auto 0px auto;
    color: #fff;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    font-family: serif;
  }
  .result {
    .tabTable .el-tab-pane {
      height: 252px;
      box-shadow: 2px 0px 2px 0px #10a4b2;
      border: 1px solid #10a4b2;
      border-radius: 10px;
    }
    .tabTable {
      height: 320px;
    }
  }
  .tabTable .el-tab-pane {
    margin-top: 0;
  }
  .el-tabs__item {
    width: 120px;
    padding: 0px;
    border: 1px solid #10a6b4;
    background-color: #000000;
    height: 30px !important;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 30px !important;
    margin: 12px 0px 12px 12px;
    color: #fff;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    border-radius: 5px;
    position: relative;
  }
}
@media screen and (max-width: 1680px) and (min-width: 1400px) {
  .imgBox {
    left: 0;
    top: 0;
    width: 100%;
    height: 380px; /**宽高100%是为了图片铺满屏幕 */
    border-right: none;
    border-left: none;
    box-shadow: 8px 0px 8px 0px #10a4b2;
    box-sizing: border-box;
    position: relative;
    .oneh1 {
      position: absolute;
      top: 33%;
      left: 13%;
      font-size: 32px;
      font-family: heiti;
      font-weight: bold;
      letter-spacing: 6px;
    }
    .twoh1 {
      position: absolute;
      top: 48%;
      left: 13%;
      font-size: 32px;
      font-family: heiti;
      font-weight: bold;
      letter-spacing: 6px;
    }
  }
}
</style>

